export var unitToNumber = function (unit) {
    return unit ? parseInt(unit, 10) : 0;
};
//# sourceMappingURL=unit-to-number.js.map